export const GUEST_FOOTER_LINKS = [
  {
    title: 'Join Naked News',
    url: '/account/purchase',
    target: '_self',
  },
  {
    title: 'Contact Us',
    url: '/contact',
    target: '_self',
  },
  {
    title: 'Report Complaint',
    url: '/contact/complaint',
    target: '_self',
  },
  {
    title: 'Media',
    url: '/media',
    target: '_self',
  },
  {
    title: 'Featured Content',
    url: '/featured-content',
    target: '_self',
  },
  {
    title: 'F.A.Q.',
    url: '/faq',
    target: '_self',
  },
  {
    title: 'Privacy Policy',
    url: '/privacy_policy',
    target: '_self',
  },
  {
    title: 'Affiliate Program Privacy Policy',
    url: '/affiliates/privacy_policy',
    target: '_self',
  },
  {
    title: 'Cookie Policy',
    url: '/cookie-policy',
    target: '_self',
  },
  {
    title: 'Cookie Settings',
    url: '/cookie-settings',
    target: '_self',
  },
  {
    title: 'Terms and Conditions',
    url: '/terms_of_service',
    target: '_self',
  },
  {
    title: 'Affiliate Program Terms and Conditions',
    url: '/affiliates/terms_of_service',
    target: '_self',
  },
  {
    title: 'Affiliates',
    url: '/affiliates',
    target: '_blank',
  },
  {
    title: 'Billing Support',
    url: '/billing/processing',
    target: '_self',
  },
  {
    title: '18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement',
    url: '/2257',
    target: '_self',
  },
];

export const FREE_USER_FOOTER_LINKS = [
  {
    title: 'Join Naked News',
    url: '/account/purchase',
    target: '_self',
  },
  {
    title: 'Free Segments',
    url: '/free-segments',
    target: '_self',
  },
  {
    title: 'Media',
    url: '/media',
    target: '_self',
  },
  {
    title: 'Featured Content',
    url: '/featured-content',
    target: '_self',
  },
  {
    title: 'Contact Us',
    url: '/contact',
    target: '_self',
  },
  {
    title: 'Report Complaint',
    url: '/contact/complaint',
    target: '_self',
  },
  {
    title: 'My Account',
    url: '/account',
    target: '_self',
  },
  {
    title: 'Cancel Subscriptions',
    url: '/account/subscriptions',
    target: '_self',
  },
  {
    title: 'F.A.Q.',
    url: '/faq',
    target: '_self',
  },
  {
    title: 'Privacy Policy',
    url: '/privacy_policy',
    target: '_self',
  },
  {
    title: 'Affiliate Program Privacy Policy',
    url: 'affiliates/privacy_policy',
    target: '_self',
  },
  {
    title: 'Cookie Policy',
    url: '/cookie-policy',
    target: '_self',
  },
  {
    title: 'Cookie Settings',
    url: '/cookie-settings',
    target: '_self',
  },
  {
    title: 'Terms and Conditions',
    url: '/terms_of_service',
    target: '_self',
  },
  {
    title: 'Affiliates',
    url: '/affiliates',
    target: '_blank',
  },
  {
    title: 'Billing Support',
    url: '/billing/processing',
    target: '_self',
  },
  {
    title: '18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement',
    url: '/2257',
    target: '_self',
  },
];
